// Pure filtering logic for pluginConfig.modules — kept free of DOM/template
// imports so it can be unit-tested (renderMenu.ts imports menu.html/menu.css,
// which vitest cannot load).

// Maps widget button keys to their corresponding pluginConfig.modules key (camelCase)
export const CONTENT_KEY_MAP: Record<string, string> = {
  'font-size':      'adjustFontSizing',
  'highlight-title': 'highlightTitle',
  'highlight-links': 'highlightLinks',
  'readable-font':  'dyslexicFont',
  'letter-spacing': 'letterSpacing',
  'line-height':    'lineHeight',
  'font-weight':    'fontWeight',
  'text-align':     'textAlign',
};

export const COLOR_KEY_MAP: Record<string, string> = {
  'dark-contrast':  'darkContrast',
  'light-contrast': 'lightContrast',
  'high-contrast':  'highContrast',
  'high-saturation':'highSaturation',
  'low-saturation': 'lowSaturation',
  'monochrome':     'monochrome',
};

export const NAV_KEY_MAP: Record<string, string> = {
  'big-cursor':     'bigCursor',
  'stop-animations':'pauseAnimations',
  'readable-guide': 'readingGuide',
};

export function filterByModule<T extends { key: string }>(
  buttons: readonly T[],
  moduleSection: Record<string, { enabled: boolean }> | undefined,
  keyMap: Record<string, string>
): T[] {
  if (!moduleSection) return buttons as T[];
  return (buttons as T[]).filter((btn) => {
    const configKey = keyMap[btn.key];
    if (!configKey) return true; // unknown key — show by default
    const mod = moduleSection[configKey];
    return mod?.enabled !== false;
  });
}

export const PROFILE_KEY_MAP: Record<string, string> = {
  'low-vision-profile':    'lowVision',
  'adhd-profile':          'adhd',
  'seizure-safe-profile':  'seizureSafe',
  'epilepsy-safe-profile': 'epilepsySafe',
};

// The profiles card — including its "Accessibility Profiles" title/select
// control — disappears when the admin section flag is explicitly off, or when
// every individual profile has been disabled by config.
export function shouldRemoveProfilesSection(
  profilesSection: { enabled?: boolean } | undefined,
  visibleCount: number
): boolean {
  return profilesSection?.enabled === false || visibleCount === 0;
}
